import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import { GAME_IMAGES_KEY } from '../gameData';
import TitleScreenBase from './TitleScreenBase';

export default class TitleFactorsScreen extends TitleScreenBase {
  create() {
    super.create();

    this.titleStamp.x = 840;
    this.titleStamp.y = 440;
  }

  createButtonContainer() {
    super.createButtonContainer();

    const item = ABCyaPhaser.Images.addImage(0, 0, 'BtnPlay', this.btnContainer, GAME_IMAGES_KEY).setOrigin(0)
      .setInteractive();
    item.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.onClickOptionButton(item));
    this.btnOptions.push(item);
    this.btnContainer.y = this.titleHeader.y + this.titleHeader.getBounds().height + 80;
  }
}